"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const Badge = ({ variant = 'green', ...props }) => {
    const variants = {
        red: 'bg-red-100 text-red-800',
        green: 'bg-green-100 text-green-800',
    };
    const classes = (0, classnames_1.default)('inline-flex items-center px-2 py-0.5 rounded text-xs font-medium', variants[variant]);
    return (react_1.default.createElement("span", { className: classes }, props.children));
};
exports.default = Badge;
